/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Order_PlaceholderInputs */

const en_search_order_placeholder = /** @type {(inputs: Search_Order_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search order...`)
};

const es_search_order_placeholder = /** @type {(inputs: Search_Order_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar pedido...`)
};

/**
* | output |
* | --- |
* | "Search order..." |
*
* @param {Search_Order_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const search_order_placeholder = /** @type {((inputs?: Search_Order_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Order_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_order_placeholder(inputs)
	return es_search_order_placeholder(inputs)
});